import React from 'react';
import ReportFrame from '../ReportFrame';

export default class JournalEntriesReport extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const reportParams = {};
    return (
      <div className='contentwrapper bg-white'>
        <ReportFrame
          reportName='Journal Entries'
          reportParams={reportParams}
          id='journalentries'
          name='journalentries'
          title='Journal Entries'
        />
      </div>
    );
  }
}
